import styled from 'styled-components';

export const Navigation = styled.nav`
  background: white;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 1000;
  font-family: 'Ubuntu', sans-serif;

  .container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.95rem 2rem;
    max-width: 1200px;
    margin: 0 auto;
    gap: 20px;

    @media (max-width: 768px) {
      padding: 0.95rem 1rem;
      gap: 10px;
    }
  }

  .nav-logo {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    span {
      @media (max-width: 480px) {
        display: none;
      }
    }
  }

  .logo-image {
    height: 46px;
    width: auto;
  }

  .nav-actions {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;

    @media (max-width: 768px) {
      gap: 8px;
    }
    
    @media (max-width: 480px) {
      gap: 4px;
    }
  }

  .social-icons {
    display: flex;
    gap: 6px;
    
    @media (max-width: 480px) {
      gap: 4px;
    }
  }

  .social-icon-link {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    padding: 0;
    background: none;
    border: none;
    color: var(--text-color);
    cursor: pointer;
    transition: color 0.2s ease, transform 0.2s ease;

    &:hover {
      color: #1976d2;
      transform: translateY(-1px);
    }

    &.yandex-maps:hover {
      color: #FF0000;
    }

    svg {
      width: 23px;
      height: 23px;
    }

    @media (max-width: 480px) {
      width: 30px;
      height: 30px;

      svg {
        width: 21px;
        height: 21px;
      }
    }
  }

  .phone-link {
    color: var(--text-color);
    font-weight: 600;
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 0.98rem;
    white-space: nowrap;
    background: none;
    border: none;
    cursor: pointer;

    &:hover {
      color: #1976d2;
    }

    @media (max-width: 480px) {
      font-size: 0.7rem;
      gap: 2px;
    }
  }

  .nav-toggle {
    display: none;
    background: none;
    border: none;
    font-size: 1.5rem;
    cursor: pointer;
    color: var(--text-color);
    padding: 0 5px;
    z-index: 1001;

    @media (max-width: 768px) {
      display: block;
    }
  }
`;

export const NavMenu = styled.ul`
  display: flex;
  list-style: none;
  gap: 1.5rem;
  margin: 0;
  padding: 0;
  align-items: center;

  @media (max-width: 992px) {
    gap: 1rem;
  }

  @media (max-width: 768px) {
    display: ${props => props.$isOpen ? 'flex' : 'none'};
    flex-direction: column;
    position: absolute;
    top: 60px;
    left: 0;
    right: 0;
    background: white;
    padding: 1rem;
    gap: 0.5rem;
    max-height: calc(100vh - 60px);
    overflow-y: auto;
    align-items: stretch;
    z-index: 1000;
    box-shadow: 0 4px 10px rgba(0,0,0,0.1);
  }

  @media (max-width: 420px) {
    top: 55px;
    max-height: calc(100vh - 55px);
    padding: 0.8rem;
  }

  .nav-menu-item {
    position: relative;
    margin: 0;

    button:not(.dropdown-item), a {
      color: var(--text-color);
      font-weight: 500;
      text-decoration: none;
      transition: color 0.3s;
      cursor: pointer;
      font-size: 0.95rem;
      padding: 0.5rem 0;
      display: block;
      white-space: nowrap;
      background: none;
      border: none;
      font-family: inherit;

      &:hover {
        color: #1976d2;
      }

      @media (max-width: 768px) {
        padding: 0.8rem 1rem;
        border-radius: 8px;
        white-space: normal;
        background: #f8f9fa;
        width: 100%;
        text-align: left;
        
        &:hover {
          background: #e9ecef;
          color: #1976d2;
        }
      }
    }

    &.dropdown {
      .dropdown-wrapper {
        display: flex;
        align-items: center;
        gap: 0.25rem;

        @media (max-width: 768px) {
          width: 100%;
        }
      }

      .dropdown-link {
        padding: 0.5rem 0;
        
        @media (max-width: 768px) {
          /* flex: 1;  ← ЗАКОММЕНТИРОВАТЬ ИЛИ УДАЛИТЬ */
          padding: 0.8rem 1rem;
          background: #f8f9fa;
          border-radius: 8px;
        }
      }

      .dropdown-arrow {
        display: none;
        background: none;
        border: none;
        cursor: pointer;
        
        @media (max-width: 768px) {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 28px;
          height: 28px;
          background: #f8f9fa;
          border-radius: 6px;
          padding: 0;
          flex-shrink: 0;
        }
      }
    }
  }

  .dropdown-menu {
    position: absolute;
    top: 100%;
    left: 0;
    background: white;
    box-shadow: 0 4px 15px rgba(0,0,0,0.15);
    border-radius: 8px;
    min-width: 220px;
    padding: 0.5rem 0;
    z-index: 1001;
    opacity: 0;
    visibility: hidden;
    transform: translateY(-10px);
    transition: all 0.3s ease;

    &.show {
      opacity: 1;
      visibility: visible;
      transform: translateY(0);
    }

    @media (max-width: 768px) {
      position: static;
      box-shadow: none;
      padding: 0;
      margin: 0.5rem 0 0.5rem 1rem;
      display: none;
      background: #f8fafc;
      border-radius: 12px;
      overflow: hidden;
      
      &.show {
        display: block;
      }
    }
  }

  .dropdown-item {
    padding: 0.75rem 1.5rem;
    cursor: pointer;
    transition: all 0.2s;
    color: var(--text-color);
    font-size: 0.9rem;
    background: none;
    border: none;
    width: 100%;
    text-align: left;
    font-family: inherit;

    &:hover {
      background: #f0f9ff;
      color: #1976d2;
      padding-left: 1.75rem;
    }

    @media (max-width: 768px) {
      padding: 0.75rem 1.5rem;
      border-bottom: 1px solid #e2e8f0;
      background: #f8f9fa;

      &:hover {
        padding-left: 1.75rem;
        background: #e9ecef;
      }

      &:last-child {
        border-bottom: none;
      }
    }
  }
`;